
import TimeSelect from "../time-select.vue";

const commonTimeSelect = {
  install: function (Vue) {
    Vue.component("commonTimeSelect", TimeSelect);
  },
};

// 导出该组件

export default commonTimeSelect;
